import '../../lib/ckeditor/ckeditor';

import * as AlloyEditor from './with-react';

export {AlloyEditor};
